import type { ModuleTagEntry } from './index';

/** Image Pixel module tags. */
export const tags: ModuleTagEntry[] = [
  'SamplesPerPixel',
  'PhotometricInterpretation',
  'PlanarConfiguration',
  'Rows',
  'Columns',
  'BitsAllocated',
  'BitsStored',
  'HighBit',
  'PixelRepresentation',
  ['SmallestPixelValue', '00280106'],
  ['LargestPixelValue', '00280107'],
  'PixelPaddingValue',
  'PixelPaddingRangeLimit',
  'RedPaletteColorLookupTableDescriptor',
  'GreenPaletteColorLookupTableDescriptor',
  'BluePaletteColorLookupTableDescriptor',
  'AlphaPaletteColorLookupTableDescriptor',
  'RedPaletteColorLookupTableData',
  'GreenPaletteColorLookupTableData',
  'BluePaletteColorLookupTableData',
  'AlphaPaletteColorLookupTableData',
  'PaletteColorLookupTableUID',
  'DistanceSourceToDetector',
  'DistanceSourceToPatient',
  'EstimatedRadiographicMagnificationFactor',
  'DistanceSourceToEntrance',
  'PixelSpacingCalibrationType',
  'PixelSpacingCalibrationDescription',
  'SequenceOfUltrasoundRegions',
];
